// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1_QFz","info":"PatientInfo_info__V-Hfc"};